module.exports = __webpack_public_path__ + "static/media/img_shensuo@2x.9ca78b91.png";